import webInterface from "./webInterface";
import map from "./map";
import users from "./users";
import clients from "./clients";
import settings from "./settings";
import tasks from "./tasks";
import changing from "./changing";
import filtersReducer from "./filtersReducer";

export default {
  webInterface,
  map,
  users,
  clients,
  settings,
  tasks,
  changing,
  filtersReducer
};



// WEBPACK FOOTER //
// ./reducers/index.js